<template lang="pug">
  ul.tree-branch
    li(v-for="item in items" :key="item.name" v-if="!item.hidden || showHidden")
      //- Ordner-Logik
      .tree-item.folder(v-if="item.type === 'folder'" @click="item.isOpen = !item.isOpen")
        span.icon(:class="item.isOpen ? 'icon-down' : 'icon-right'") 📂
        span.label {{ item.name }}
      
      //- Rekursion: Wenn der Ordner offen ist, zeige die Kinder
      FileTree(
        v-if="item.type === 'folder' && item.isOpen" 
        :items="item.children" 
        :showHidden="showHidden"
        @select="handleSelect"
      )

      //- Datei-Logik
      .tree-item.file(v-if="item.type === 'file'" @click="handleSelect(item.id)")
        span.icon.ts-blue TS
        span.label {{ item.name }}
</template>

<script>
// FileTree.vue
export default {
  name: 'FileTree', // EXTREM WICHTIG für Vue 2 Rekursion
  props: {
    items: {
      type: Array,
      required: true
    },
    showHidden: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelect(id) {
      // Wir geben den Event nach oben weiter (Bubbling)
      this.$emit('select', id);
    }
  }
}
</script>

<style lang="less">
.tree-branch {
  list-style: none;
  padding-left: 1.2rem; // Hier entsteht die visuelle Hierarchie
  margin: 0;

  .tree-item {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    cursor: pointer;
    font-family: 'Fira Code', monospace;
    font-size: 0.9rem;
    white-space: nowrap;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }

    .icon {
      margin-right: 8px;
      width: 16px;
      text-align: center;
    }

    .ts-blue {
      font-size: 0.6rem;
      background: #3178c6;
      color: white;
      padding: 1px 2px;
      border-radius: 2px;
      font-weight: bold;
    }

    &.file {
      color: #8cf;
      &:hover { color: #42b883; }
    }

    &.folder {
      color: #ccc;
      font-weight: bold;
    }
  }
}
</style>